import { useEffect, useState } from "react";
import {
  ReferenceArrayInput,
  required,
  AutocompleteArrayInput,
  useDataProvider,
} from "react-admin";
import { useField } from "react-final-form";

const RouteInput = () => {
  const [busSchedulePlan, setBusSchedulePlan] = useState<any>();

  const provider = useDataProvider();
  const {
    input: { value },
  } = useField("busScheduleId");

  const parentsInput = useField("parentIds");
  const driversInput = useField("driverIds");
  const busAssistantInput = useField("busAssistantIds");

  const reset = () => {
    parentsInput.input.onChange([]);
    driversInput.input.onChange([]);
    busAssistantInput.input.onChange([]);
  };

  useEffect(() => {
    if (value !== "") {
      getBusSchedulePlans(value).then((result) => {
        setBusSchedulePlan(result);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const getBusSchedulePlans = async (busScheduleId: Number) => {
    return await provider
      .getList("busSchedulePlans", {
        filter: { BusScheduleId: busScheduleId },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then((result) => {
        return result.data[0];
      });
  };

  return (
    <ReferenceArrayInput
      label="Select Route"
      source="routeIds"
      reference="routes"
      filter={{
        RoutePlanId: busSchedulePlan && busSchedulePlan.routePlan
          ? Number(busSchedulePlan.routePlan?.id)
          : 0,
      }}
      sort={{ field: "name", order: "ASC" }}
      onChange={reset}
      perPage={9999}
      validate={required()}
    >
      <AutocompleteArrayInput optionText="name" />
    </ReferenceArrayInput>
  );
};

export default RouteInput;
